"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var WithErrorHandler_1 = require("../../components/WithErrorHandler");
var baseModal_1 = __importDefault(require("./baseModal"));
var Index = function (props) {
    var titleRelate = react_1.useMemo(function () {
        return {
            mainTitle: typeof props.titleRelate !== 'undefined' && props.titleRelate.mainTitle || '预约试驾',
            btnMainTitle: typeof props.titleRelate !== 'undefined' && props.titleRelate.btnSubTitle || '立即预约',
            btnSubTitle: typeof props.titleRelate !== 'undefined' && props.titleRelate.btnMainTitle || '专业顾问给您安排线下试驾、体验车辆乘驾感受'
        };
    }, [JSON.stringify(props.titleRelate)]);
    return (react_1.default.createElement(baseModal_1.default, __assign({}, props, { titleRelate: __assign({}, titleRelate) })));
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(Index));
